var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[(
        _vm.isAdmin ||
        _vm.environmentUser.canAddUsers ||
        _vm.environmentUser.canRemoveUsers ||
        _vm.environmentUser.canEditProfiles ||
        _vm.environmentUser.canManageRoles
      )?_c('v-col',{attrs:{"cols":"12","md":"6","lg":"4"}},[_c('v-card',[_c('v-card-title',[_vm._v("Usuarios")]),_c('v-card-subtitle',[_vm._v("Administra Usuarios")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":"","color":"primary","to":"/manage/users"}},[_vm._v(" Lista de usuarios "),_c('v-icon',{attrs:{"right":""}},[_vm._v("arrow_forward")])],1)],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }